import { render, staticRenderFns } from "./AddFieldButton.vue?vue&type=template&id=48aab4f0"
import script from "./AddFieldButton.vue?vue&type=script&lang=ts"
export * from "./AddFieldButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports